import {ValueObject} from '@s-ui/domain'

export class SearchRequestValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {Array} params.bodyTypeIds
   * @param {Array} params.equipments
   * @param {Array} params.fuelTypeIds
   * @param {Array} params.provinceId
   * @param {Array} params.provinceIds
   * @param {Number} params.category2Id
   * @param {Number} params.category3Id
   * @param {Number} params.categoryId
   * @param {Number} params.city
   * @param {Number} params.cityId
   * @param {Number} params.commitmentMonths
   * @param {Number} params.contractId
   * @param {Number} params.drivenWheelsIds
   * @param {Number} params.environmentalLabels
   * @param {Array} params.excludedAdIds
   * @param {Array} params.excludedVehicles
   * @param {Number} params.fee
   * @param {Number} params.hp
   * @param {Number} params.makeId
   * @param {Number} params.offerTypeId
   * @param {Number} params.page
   * @param {Number} params.sellerTypeId
   * @param {Number} params.sortOrder
   * @param {Number} params.transmissionTypeId
   * @param {Object} params.kms
   * @param {Object} params.litres
   * @param {Object} params.location
   * @param {Object} params.model
   * @param {Object} params.monthlySubscriptionFee
   * @param {Object} params.price
   * @param {Object} params.year
   * @param {String} params.make
   * @param {String} params.modelVersionId
   * @param {String} params.searchText
   * @param {String} params.sortBy
   * @param {String} params.version
   * @param {Number} params.instalment
   */

  static validate({categoryId, invalidRequestSearchErrorFactory, offerTypeId, page, sortOrder}) {
    const hasCategory = typeof categoryId !== 'undefined'
    const hasOfferType = typeof offerTypeId !== 'undefined'

    if (
      typeof page !== 'number' ||
      (Boolean(sortOrder) && sortOrder.toUpperCase() !== 'DESC' && sortOrder.toUpperCase() !== 'ASC')
    ) {
      throw invalidRequestSearchErrorFactory('invalid search request')
    }

    if (hasCategory && typeof categoryId !== 'number') {
      throw invalidRequestSearchErrorFactory('category is not valid')
    }

    if (hasOfferType && typeof offerTypeId !== 'number') {
      throw invalidRequestSearchErrorFactory('offer type is not valid')
    }
  }

  getContractId() {
    return this._contractId
  }

  getMakeId() {
    return this._makeId
  }

  setContractId(contractId) {
    this._contractId = contractId
  }

  toCleanJSON() {
    return JSON.parse(JSON.stringify(this.toJSON()))
  }
}
